module.exports = __webpack_public_path__ + "70d70f675b9c55ea4fcaf9c5b26669f7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TW.svg
// module id = Fqkr
// module chunks = 0